"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableDetail = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _styles = require("@material-ui/core/styles");

var _solarReact = require("@solar/solar-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CARD_LIST_OVERVIEW = 0;
var TABLE_DETAIL = 1;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      height: '100%'
    }, _defineProperty(_root, theme.breakpoints.up('sm'), {
      margin: 24
    }), _defineProperty(_root, "display", 'flex'), _defineProperty(_root, "flexDirection", 'column'), _defineProperty(_root, "position", 'relative'), _root),
    avatar: {
      backgroundColor: theme.palette.primary.main
    },
    header: {
      flex: '0 0 auto'
    },
    list: {
      flex: '1 1 auto'
    }
  };
});

var CardListOverviewToTableDetail = function CardListOverviewToTableDetail(_ref) {
  var _ref$cardListOverview = _ref.cardListOverview,
      cardItems = _ref$cardListOverview.items,
      renderCardBody = _ref$cardListOverview.renderCardBody,
      _ref$tableDetail = _ref.tableDetail,
      title = _ref$tableDetail.title,
      subtitle = _ref$tableDetail.subtitle,
      columns = _ref$tableDetail.columns,
      getTableItems = _ref$tableDetail.items,
      renderTableRow = _ref$tableDetail.renderTableRow,
      onItemClick = _ref$tableDetail.onItemClick,
      _selectedCardItem = _ref.selectedCardItem,
      setSelectedCardItem = _ref.setSelectedCardItem,
      autoOpen = _ref.autoOpen;
  // auto select card if only 1
  var selectedCardItem = _selectedCardItem || autoOpen && cardItems.length === 1 && cardItems[0];
  var view = selectedCardItem ? TABLE_DETAIL : CARD_LIST_OVERVIEW;

  if (view === CARD_LIST_OVERVIEW) {
    return /*#__PURE__*/_react["default"].createElement(CardListOverview, {
      items: cardItems,
      renderItemBody: renderCardBody,
      onItemClick: setSelectedCardItem
    });
  }

  if (view === TABLE_DETAIL) {
    return /*#__PURE__*/_react["default"].createElement(TableDetail, {
      title: title(selectedCardItem),
      subtitle: subtitle(selectedCardItem),
      columns: columns,
      items: getTableItems(selectedCardItem),
      onClose: function onClose() {
        return setSelectedCardItem(null);
      },
      renderRowItem: renderTableRow,
      onItemClick: onItemClick,
      closeable: !!_selectedCardItem
    });
  } // Shouldn't happen


  return null;
};

var CardListOverview = function CardListOverview(_ref2) {
  var items = _ref2.items,
      renderItemBody = _ref2.renderItemBody,
      onItemClick = _ref2.onItemClick;

  if (items == null) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, null, /*#__PURE__*/_react["default"].createElement(_solarReact.CardList, {
    items: items
  }, function (item) {
    return /*#__PURE__*/_react["default"].createElement(_core.Card, null, /*#__PURE__*/_react["default"].createElement(_core.CardActionArea, {
      onClick: function onClick() {
        return onItemClick(item);
      }
    }, renderItemBody(item)));
  }));
};

var TableDetail = function TableDetail(_ref3) {
  var title = _ref3.title,
      subtitle = _ref3.subtitle,
      columns = _ref3.columns,
      items = _ref3.items,
      onClose = _ref3.onClose,
      renderRowItem = _ref3.renderRowItem,
      onItemClick = _ref3.onItemClick,
      closeable = _ref3.closeable;
  var classes = useStyles();
  var theme = (0, _core.useTheme)();
  var isPhone = !(0, _core.useMediaQuery)(theme.breakpoints.up('sm'));
  return /*#__PURE__*/_react["default"].createElement(_core.Card, {
    className: (0, _classnames["default"])(classes.root),
    elevation: isPhone ? 0 : 2
  }, closeable && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    onClick: onClose,
    style: {
      position: 'absolute',
      right: 8,
      top: 8
    }
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.CardHeader, {
    avatar: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
      "aria-label": "Recipe",
      className: classes.avatar
    }, items.length > 99 ? '99+' : items.length),
    title: title,
    subheader: subtitle,
    className: classes.header
  }), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.list
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.VirtualizedTable, {
    headerHeight: 64,
    rowHeight: 64,
    rowCount: items.length,
    rowGetter: function rowGetter(_ref4) {
      var index = _ref4.index;
      return renderRowItem(items[index]);
    },
    columns: columns,
    onRowClick: onItemClick
  })));
};

exports.TableDetail = TableDetail;
var _default = CardListOverviewToTableDetail;
exports["default"] = _default;